


























import { snakeCase } from 'lodash'
import i18n from 'vue-i18n'
import { Component, Prop } from 'vue-property-decorator'

import {
  GroupedBotProperty,
  PropertyFieldType
} from '../../../../../../../../../BotProperties/components/Properties/types'
import FileDescriptorsPreview from '../../../../../../../../../File/FilesList/FileDescriptorsPreview.vue'
import { StepUnit } from '../../../../../../../../../PeriodSimplifier/types'
import { UseFields } from '../../../../../../../../../Pi'
import { PropertyActionProxy } from '../../../logic/Actions/PropertyAction/PropertyActionProxy'
import {
  PropValueCalculate,
  PropValueConstant,
  PropValueNow,
  PropValueProperty,
} from '../../../logic/Actions/PropertyAction/PropertyActionValue'
import { PropertyActionType } from '../../../logic/Actions/PropertyAction/types'

@Component({
  data() {
    return {
      snakeCase,
      PropertyFieldType
    }
  },
  components: {
    FileDescriptorsPreview
  }
})
export default class PropertyAction extends UseFields {
  @Prop() action!: PropertyActionProxy

  @Prop() i18n!: i18n

  @Prop() mediaTargetId!: string

  @Prop() getProperties!: () => Array<GroupedBotProperty>

  getPropertyName(index: number): string {
    // if (!FlowHelper.flowIsReadonly) {
    const property = this.getProperties().find((prop) => prop.id === index)

    if (property) {
      return property.name ?? property.type
    }
    // }

    return this.i18n.t('property_is_undefined').toString()
  }

  get propValue(): string {
    return this.getValue()
  }

  get filesViewValue() {
    const propValue = this.action.action.value

    if (propValue instanceof PropValueConstant) {
      if (this.action.currentProperty && this.action.currentProperty.type === PropertyFieldType.Files) {
        return JSON.parse(propValue.value as string)
      }

      return propValue.value
    }

    return ''
  }

  //todo
  currentUnit = 0

  get unitOptions(): Array<number> {
    return [ StepUnit.Second, StepUnit.Minute, StepUnit.Hour, StepUnit.Day, StepUnit.Week, StepUnit.Month ]
      .map((unit: StepUnit) =>  unit / StepUnit.Second)
  }

  get unitLabel() {
    const action = this.action.action.value

    if (action instanceof PropValueConstant && typeof action.value === 'number') {
      return this.i18n.tc(`period_simplifier_${ this.currentUnit }`, action.value).toString()
    }

    return ''
  }

  calculateCurrentUnit(): void {
    const action = this.action.action.value

    if (action instanceof PropValueConstant && typeof action.value === 'number') {
      const value = action.value

      if (value !== 0) {
        for (const unitOption of this.unitOptions) {
          const unit: StepUnit = unitOption
          const remainder = value % unit

          if (value >= unit && remainder === 0) {
            this.currentUnit = unit
          }
        }
      } else {
        this.currentUnit = this.unitOptions[0]
      }
    }
  }

  // eslint-disable-next-line sonarjs/cognitive-complexity
  getValue(): string {
    const action = this.action.action
    const valueSource = action.value

    if (!action.property_index) {
      return this.i18n.t('flow_actions_node_select_property').toString()
    } else {
      const actionType = action.action.toLowerCase()

      if (valueSource instanceof PropValueProperty) {
        if (valueSource.property_index) {
          return this.i18n.t(`flow_actions_node_property_index_${ actionType }_text`, {
            firstProperty: this.getPropertyName(action.property_index),
            secondProperty: this.getPropertyName(valueSource.property_index)
          }).toString()
        } else {
          return this.i18n.t('flow_actions_node_property_index_is_null_text').toString()
        }
      } else if (valueSource instanceof PropValueCalculate) {
        if (valueSource.value) {
          return this.i18n.t(`flow_actions_node_calculate_value_${ actionType }_text`,
            { property: this.getPropertyName(action.property_index), calculate: valueSource.value }).toString()
        } else {
          return this.i18n.t('flow_actions_node_calculate_value_is_empty_text').toString()
        }
      } else if (valueSource instanceof PropValueConstant) {
        const property = this.action.currentProperty

        if (property?.type === PropertyFieldType.Flag || valueSource.value ) {
          if (typeof valueSource.value === 'boolean' || [ 'true', 'false' ].includes(valueSource.value as string)) {
            const trueFlag = this.i18n.t('flow_actions_node_constant_value_flag_true_text').toString()
            const falseFlag = this.i18n.t('flow_actions_node_constant_value_flag_false_text').toString()

            return this.i18n.t(`flow_actions_node_constant_value_${ actionType }_text`,
              { property: this.getPropertyName(action.property_index), value: valueSource.value || valueSource.value === 'true' ? trueFlag : falseFlag }).toString()

          } else if (property && [ PropertyFieldType.DateTime, PropertyFieldType.Date, PropertyFieldType.Time ].includes(property.type) && action.action !== PropertyActionType.Set) {
            this.calculateCurrentUnit()

            const value = valueSource.value as number / this.currentUnit ;
            const unitLabel = this.unitLabel;
            const str = ` ${ value } ${ unitLabel }`

            return this.i18n.t(`flow_actions_node_constant_value_${ actionType }_text`,
              { property: this.getPropertyName(action.property_index), value: str }).toString()
          } else if (property && property.type === PropertyFieldType.Files) {
            return this.i18n.t(`flow_actions_node_constant_value_${ actionType }_text`,
              { property: this.getPropertyName(action.property_index) }).toString()

          } else {
            return this.i18n.t(`flow_actions_node_constant_value_${ actionType }_text`,
              { property: this.getPropertyName(action.property_index), value: valueSource.value }).toString()
          }
        } else {
          return this.i18n.t('flow_actions_node_constant_value_is_empty_text').toString()
        }
      } else if (valueSource instanceof PropValueNow) {
        return this.i18n.t('flow_actions_node_now_text', { property: this.getPropertyName(action.property_index) }).toString()
      } else {
        return this.i18n.t('flow_actions_node_select_action_type').toString()
      }
    }
  }
}
